// useProfileItems.js
import { useState, useEffect } from "react";

export const useProfileItems = (profileId, fetchFn) => {
    const [items, setItems] = useState(null); // null = not loaded yet
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!profileId) return;

        const loadItems = async () => {
            setLoading(true);
            try {
                const data = await fetchFn(profileId);
                setItems(data || []);
            } catch (err) {
                console.error(err);
                setItems([]);
            } finally {
                setLoading(false);
            }
        };

        loadItems();
    }, [profileId, fetchFn]);

    return { items, loading, setItems };
};